<!-- sidenav component -->
<div class="sidenav">
    <div class="nav" #sidenav>
        <div class="logo">
            <img [src]="logoPath" alt="NowCorp icon" width="50px" height="50px" />
        </div>  
        <div class="icons">
            <a 
                class="icon" 
                [ngStyle]="{'background-color': icon.recentlySelected ? '#ebebeb' : ''}" 
                *ngFor="let icon of icons" 
                [class.disabled]="icon.disabled"
                [class.selected]="icon.selected"
                (click)="this.navigate(icon)" 
                (keydown.Space)="this.navigate(icon)"
                (keydown.enter)="this.navigate(icon)" 
                tabindex="2"
            >
                <ng-container *ngIf="!icon.recentlySelected || icon.selected">
                    <img [src]="icon.imagePath" alt="{{icon.name}} icon" width="50px" height="50px" />
                    <img [src]="icon.imagePathHover" alt="{{icon.name}} hover icon" width="50px" height="50px" />
                    <p>{{icon.name}}</p>
                </ng-container>
                
                <div *ngIf="icon.recentlySelected && !icon.selected">
                    <span style="height: 50px; width: 50px; display: flex; justify-content: center;">
                        <kendo-loader
                        [type]="loader.type"
                        [themeColor]="loader.themeColor"
                        [size]="loader.size"
                        style="align-self: center;"
                        >
                        </kendo-loader>
                    </span>
                </div>
            </a>
        </div>
    </div>
    <div class="mobile-nav">
        <div class="bar {{this.isMobileOpen ? 'open' : 'close'}}" #mobileSidenav>
            <div class="logo">
                <img [src]="logoPath" alt="NowCorp icon" width="50px" height="50px" />
            </div>  
            <div class="icons">
                <a class="icon" 
                    *ngFor="let icon of icons" 
                    [class.disabled]="icon.disabled"
                    [class.selected]="icon.selected"
                    (click)="this.navigate(icon)" 
                    (keydown.Space)="this.navigate(icon)"
                    (keydown.enter)="this.navigate(icon)" 
                    tabindex="2"
                >
                    <ng-container *ngIf="!icon.recentlySelected || icon.selected">
                        <img [src]="icon.imagePath" alt="{{icon.name}} icon" width="50px" height="50px" />
                        <img [src]="icon.imagePathHover" alt="{{icon.name}} hover icon" width="50px" height="50px" />
                        <p>{{icon.name}}</p>
                    </ng-container>

                    <div *ngIf="icon.recentlySelected && !icon.selected">
                        <span style="height: 50px; width: 50px; display: flex; justify-content: center;">
                            <kendo-loader
                            [type]="loader.type"
                            [themeColor]="loader.themeColor"
                            [size]="loader.size"
                            style="align-self: center;"
                            >
                            </kendo-loader>
                        </span>
                    </div>
                </a>
            </div>
        </div>
        <div class="toggle" 
        (click)="this.openMobile()" 
        (keydown.Space)="this.openMobile()"
        (keydown.enter)="this.openMobile()"
        tabindex="{{!this.isMobileOpen ? '0' : '-1'}}">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <line x1="10" y1="10" x2="20" y2="10" stroke="#244538" stroke-width="2" stroke-linecap="round" />
                <line x1="10" y1="16" x2="30" y2="16" stroke="#244538" stroke-width="2" stroke-linecap="round" />
                <line x1="10" y1="22" x2="40" y2="22" stroke="#244538" stroke-width="2" stroke-linecap="round" />
            </svg>
        </div>
    </div>
</div>
